import { Socket } from 'socket.io-client'
import CommunitiesListener from './CommunityListeners'
import CoursesListener from './CoursesListeners'
import FileDownloader from './FileDownloader'
import UsersListener from './UserListeners'
const listeners = [CommunitiesListener, CoursesListener, UsersListener, FileDownloader]
export const InitializeWebsocketListeners = (socket: Socket) => listeners.forEach(listener => new listener(socket))
